export default "__VITE_ASSET__k36IBNyQ__"